import React from "react"
import { Link } from "gatsby"

/** CSS */
import "../../styles/components/header.scss"

/** Image */
const tricolor = require("../../../static/images/tricolor.svg") as string
const age = require("../../../static/images/18.svg") as string
const food = require("../../../static/images/ic_Foodlogo.svg") as string

export const Header = () => {
  return (
    <div className={"header-wrapper"}>
      <div className={"header-logo"}>
        <Link to={"/"}>
          <img className={"header-image"} src={food} alt="Еда" />
        </Link>

        <p className={"header-age"}>16+</p>
      </div>

      <div className={"header-image__block"}>
        <img
          className={"header-image middle-img"}
          src={tricolor}
          alt="Триколор"
        />
      </div>
    </div>
  )
}

export default Header
